module.exports = __webpack_public_path__ + "img/Carte-virtuelle-ecobank.a298be41.png";